import { Upload, X, FileText, Loader2 } from "lucide-react";

export default function LeadFormFileUpload({ files, uploading, onUpload, onRemove }) {
  return (
    <div className="mt-6">
      <label className="field-label">Grundriss / Fotos (optional)</label>
      <label
        className="surface flex items-center justify-center gap-3 py-6 cursor-pointer hover:border-[#18E096] transition-colors"
        data-testid="file-upload-label"
      >
        {uploading ? (
          <Loader2 size={18} strokeWidth={1.5} className="text-[#18E096] animate-spin" />
        ) : (
          <Upload size={18} strokeWidth={1.5} className="text-[#18E096]" />
        )}
        <span className="text-sm text-[#AEB7B7]">
          {uploading
            ? "Wird hochgeladen…"
            : "Datei wählen (JPG, PNG, WEBP, PDF · max. 15 MB)"}
        </span>
        <input
          type="file"
          accept="image/jpeg,image/png,image/webp,application/pdf"
          multiple
          onChange={onUpload}
          className="hidden"
          data-testid="input-file-upload"
        />
      </label>
      {files.length > 0 && (
        <ul className="mt-3 space-y-2" data-testid="file-list">
          {files.map((f) => (
            <li
              key={f.id}
              className="flex items-center justify-between border border-[rgba(255,255,255,0.12)] px-3 py-2 text-sm"
            >
              <div className="flex items-center gap-3 text-[#AEB7B7]">
                <FileText size={16} strokeWidth={1.5} />
                <span className="text-white">{f.original_filename}</span>
                <span className="text-xs">({Math.round(f.size / 1024)} KB)</span>
              </div>
              <button
                type="button"
                onClick={() => onRemove(f.id)}
                className="text-[#AEB7B7] hover:text-white"
                aria-label="Entfernen"
                data-testid={`remove-file-${f.id}`}
              >
                <X size={16} strokeWidth={1.5} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
